import appGlobalConfig from "@shared/config/app/appGlobal.config";

const clearDataStorage = () => {
    localStorage.removeItem(appGlobalConfig.CONFIG_MODULE.LOCALSTORAGE_KEY);
};

export default clearDataStorage;